import { scrollbarStyle } from '@rulebooks/evidend-titan';
import { createGlobalStyle } from 'styled-components';

const GlobalSiteStyling = createGlobalStyle`
  body {
    margin: 0;
    //padding-bottom: 80px;
    height: 100vh;
    ${scrollbarStyle.pageScrollbar};
    overflow-y: auto;
    font-family: Source Sans Pro, sans-serif;
  }

  h1 {
    color: #262626;
    margin-block: 40px;
    font-size: 42px;
    font-weight: 600;
  }

  // TODO: Workaround for ActionMenu being clipped by TableContainer.
  div[data-test-id="table"] {
    overflow-x: visible;
  }

  // The onboarding modal contains a step per release note; wrap the pagination
  // dots so they don't overflow the modal when there are many notes.
  [data-test-id="onboardingModal"] [data-test-id="paginationDots"] > div {
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 8px;
  }

  strong {
    font-weight: 600;
  }
`;

export { GlobalSiteStyling };
